interface SkipLinkProps {
  children?: string;
  targetId?: string;
}

export function SkipLink({
  children = "Skip to main content",
  targetId = "main",
}: SkipLinkProps): JSX.Element {
  return (
    <a
      className="sr-only rounded-full bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground shadow-halo focus-visible:not-sr-only focus-visible:fixed focus-visible:left-4 focus-visible:top-4 focus-visible:z-[100] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
      href={`#${targetId}`}
    >
      {children}
    </a>
  );
}
